import React from "react";
import { useTranslation } from "react-i18next"; // For localization
import { Box, Typography, useTheme, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom"; // For navigation
import buildingImg from "images/reinforcement/construction.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"; // Right arrow icon

const ReinforcementSystemMobile = ({
  imageSrc = buildingImg,
  primaryButtonUrl = "/business-reinforcement",
}) => {
  const { t } = useTranslation(); // Initialize translation hook
  const theme = useTheme();
  const navigate = useNavigate(); // Hook for navigation

  // Handle arrow click to navigate
  const handleArrowClick = () => {
    navigate(primaryButtonUrl); // Navigate to the specified URL
  };

  return (
    <Box
      id="reinforcement-system"
      sx={{
        backgroundColor: "#ffffff", // White background
        padding: theme.spacing(2), // Add padding
        borderRadius: 2, // Rounded corners
        boxShadow: 1, // Subtle shadow
        textAlign: "center", // Center align text
      }}
    >
      {/* Image Column */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: theme.spacing(2),
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          alt="Reinforcement System"
          sx={{
            width: "100%",
            borderRadius: 2, // Rounded corners
            boxShadow: 3, // Add shadow
          }}
        />
      </Box>

      {/* Text Column */}
      <Box>
        <Typography
          variant="h5"
          component="h4"
          sx={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            color: theme.palette.primary.main, // Use primary color
            marginBottom: theme.spacing(1),
          }}
        >
          {t("business.reinforcement.heading")}
        </Typography>
        <Box
          sx={{
            textAlign: "left",
            borderLeft: 2,
            borderColor: "primary.main",
            paddingLeft: 1,
            marginBottom: theme.spacing(2),
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary, // Use secondary text color
              fontSize: "0.9rem",
            }}
          >
            {t("business.reinforcement.description")}
          </Typography>
        </Box>

        {/* Arrow Icon for Navigation */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // Center the arrow
            marginTop: theme.spacing(2),
          }}
        >
          <IconButton
            onClick={handleArrowClick}
            sx={{
              backgroundColor: theme.palette.primary.main, // Primary color background
              color: "#ffffff", // White icon
              borderRadius: "50%", // Circular shape
              padding: theme.spacing(1),
              "&:hover": {
                backgroundColor: theme.palette.primary.dark, // Darker on hover
              },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: "2rem" }} />{" "}
            {/* Larger arrow */}
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ReinforcementSystemMobile;
